import Link from "next/link"

export function DzpLogo({
  href = "/",
  size = 22,
}: {
  href?: string
  size?: number
}) {
  return (
    <Link
      href={href}
      style={{
        fontSize: size,
        fontWeight: 800,
        letterSpacing: "-0.04em",
        color: "#f708a3",
        fontFamily: "var(--font-fraunces), Georgia, serif",
        lineHeight: 1,
      }}
    >
      dzp.
    </Link>
  )
}
